import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
export const LeadForm = ({ onSubmit, onClose, title = '', subtitle = '', questions = [], lang = 'en', }) => {
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [answers, setAnswers] = useState(() => Object.fromEntries(questions.map(q => [q.id, q.type === 'checkbox' ? [] : ''])));
    const [state, setState] = useState('idle');
    const [errors, setErrors] = useState({});
    const validate = () => {
        const newErrors = {};
        if (!name.trim() || name.trim().length < 2)
            newErrors.name = locale[lang]['enterNameMin2'];
        const phoneClean = phone.replace(/\D/g, '');
        if (!phoneClean || phoneClean.length < 10)
            newErrors.phone = locale[lang]['enterValidPhone'];
        questions.forEach(q => {
            if (!q.required)
                return;
            const val = answers[q.id];
            if (q.type === 'checkbox') {
                if (val.length === 0)
                    newErrors[q.id] = locale[lang]['selectAtLeastOne'];
            }
            else {
                if (!val.trim())
                    newErrors[q.id] = locale[lang]['requiredField'];
            }
        });
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // const formatPhone = (value: string) => {
    //     const digits = value.replace(/\D/g, '');
    //     if (digits.length === 0) return '';
    //     if (digits.length <= 1) return `+${digits}`;
    //     if (digits.length <= 4) return `+${digits[0]} (${digits.slice(1)}`;
    //     if (digits.length <= 7) return `+${digits[0]} (${digits.slice(1, 4)}) ${digits.slice(4)}`;
    //     if (digits.length <= 9) return `+${digits[0]} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    //     return `+${digits[0]} (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7, 9)}-${digits.slice(9, 11)}`;
    // };
    const formatPhone = (value) => {
        let digits = value.replace(/[^\d+]/g, '');
        // оставляем только один "+" в начале
        if (digits.startsWith('+')) {
            digits = '+' + digits.slice(1).replace(/\+/g, '');
        }
        else {
            digits = '+' + digits.replace(/\+/g, '');
        }
        const clean = digits.slice(1); // без +
        if (!clean)
            return '';
        // просто разбиваем по группам для удобства чтения
        const parts = [];
        for (let i = 0; i < clean.length; i += 3) {
            parts.push(clean.slice(i, i + 3));
        }
        return `+${parts.join(' ')}`.trim();
    };
    const handleCheckbox = (id, option, checked) => {
        setAnswers(prev => {
            const current = prev[id] ?? [];
            return {
                ...prev,
                [id]: checked ? [...current, option] : current.filter(v => v !== option),
            };
        });
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleText = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleSelect = (id, value) => {
        setAnswers(prev => ({ ...prev, [id]: value }));
        if (errors[id])
            setErrors(prev => ({ ...prev, [id]: '' }));
    };
    const handleSubmit = async () => {
        console.log(validate());
        if (!validate())
            return;
        setState('loading');
        try {
            const t = await onSubmit({ name: name.trim(), phone, answers });
            console.log(t);
            setState('success');
        }
        catch {
            setState('error');
        }
    };
    const inputStyle = (hasError) => ({
        width: '100%',
        padding: '10px 12px',
        borderRadius: 8,
        border: `1.5px solid ${hasError ? '#e53e3e' : '#e2e8f0'}`,
        fontSize: 14,
        outline: 'none',
        boxSizing: 'border-box',
        background: '#fff',
        color: '#1a202c',
    });
    if (state === 'success') {
        return (_jsx("div", { style: overlayStyle, children: _jsxs("div", { style: cardStyle, children: [onClose && _jsx(CloseButton, { onClick: onClose }), _jsxs("div", { style: { textAlign: 'center', padding: '12px 0' }, children: [_jsx("div", { style: { fontSize: 48, marginBottom: 12 }, children: "\u2713" }), _jsx("div", { style: { fontWeight: 700, fontSize: 18, color: '#1a202c', marginBottom: 6 }, children: locale[lang]['requestSent'] }), _jsx("div", { style: { color: '#718096', fontSize: 14 }, children: locale[lang]['contactSoon'] })] })] }) }));
    }
    return (_jsx("div", { style: overlayStyle, children: _jsxs("div", { style: cardStyle, onKeyDown: e => e.key === 'Enter' && handleSubmit(), children: [onClose && _jsx(CloseButton, { onClick: onClose }), _jsxs("div", { style: { marginBottom: 20 }, children: [_jsx("div", { style: { fontWeight: 700, fontSize: 18, color: '#1a202c', marginBottom: 4 }, children: title ? locale[lang]['leaveRequest'] : title }), _jsx("div", { style: { color: '#718096', fontSize: 13 }, children: subtitle ? locale[lang]['contactSoon'] : subtitle })] }), _jsxs("div", { style: { marginBottom: 14 }, children: [_jsx("label", { style: labelStyle, children: locale[lang]['name'] }), _jsx("input", { type: "text", placeholder: locale[lang]['yourName'], value: name, onChange: e => { setName(e.target.value); if (errors.name)
                                setErrors(p => ({ ...p, name: '' })); }, style: inputStyle(!!errors.name), disabled: state === 'loading' }), errors.name && _jsx("div", { style: errorStyle, children: errors.name })] }), _jsxs("div", { style: { marginBottom: questions.length ? 20 : 20 }, children: [_jsx("label", { style: labelStyle, children: locale[lang]['phone'] }), _jsx("input", { type: "tel", placeholder: "999 000 00 00", value: phone, onChange: e => { setPhone(formatPhone(e.target.value)); if (errors.phone)
                                setErrors(p => ({ ...p, phone: '' })); }, style: inputStyle(!!errors.phone), disabled: state === 'loading' }), errors.phone && _jsx("div", { style: errorStyle, children: errors.phone })] }), questions.map(q => (_jsxs("div", { style: { marginBottom: 16 }, children: [_jsxs("label", { style: labelStyle, children: [q.label, q.required && _jsx("span", { style: { color: '#e53e3e', marginLeft: 3 }, children: "*" })] }), q.type === 'text' && (_jsx("input", { type: "text", placeholder: q.placeholder ?? '', value: answers[q.id] ?? '', onChange: e => handleText(q.id, e.target.value), style: inputStyle(!!errors[q.id]), disabled: state === 'loading' })), q.type === 'select' && (_jsxs("select", { value: answers[q.id] ?? '', onChange: e => handleSelect(q.id, e.target.value), disabled: state === 'loading', style: { ...inputStyle(!!errors[q.id]), appearance: 'auto' }, children: [_jsx("option", { value: "", children: locale[lang]['selectPlaceholder'] }), q.options?.map(opt => (_jsx("option", { value: opt, children: opt }, opt)))] })), q.type === 'checkbox' && (_jsx("div", { style: { display: 'flex', flexDirection: 'column', gap: 8 }, children: q.options?.map(opt => {
                                const checked = (answers[q.id] ?? []).includes(opt);
                                return (_jsxs("label", { style: {
                                        display: 'flex', alignItems: 'center', gap: 8,
                                        fontSize: 13, color: '#2d3748', cursor: 'pointer',
                                    }, children: [_jsx("input", { type: "checkbox", checked: checked, onChange: e => handleCheckbox(q.id, opt, e.target.checked), disabled: state === 'loading', style: { width: 15, height: 15, cursor: 'pointer', accentColor: '#2d3748' } }), opt] }, opt));
                            }) })), errors[q.id] && _jsx("div", { style: errorStyle, children: errors[q.id] })] }, q.id))), state === 'error' && (_jsx("div", { style: {
                        background: '#fff5f5', border: '1px solid #fed7d7',
                        borderRadius: 8, padding: '10px 12px',
                        color: '#c53030', fontSize: 13, marginBottom: 14,
                    }, children: locale[lang]['sendError'] })), _jsx("button", { onClick: handleSubmit, disabled: state === 'loading', style: {
                        width: '100%', padding: '11px', borderRadius: 8,
                        border: 'none', background: state === 'loading' ? '#a0aec0' : '#2d3748',
                        color: '#fff', fontWeight: 600, fontSize: 14,
                        cursor: state === 'loading' ? 'not-allowed' : 'pointer',
                    }, children: state === 'loading' ? locale[lang]['sending'] : locale[lang]['send'] })] }) }));
};
// sub-components & styles unchanged
const CloseButton = ({ onClick }) => (_jsx("div", { onClick: onClick, style: {
        position: 'absolute', top: 12, right: 14, cursor: 'pointer',
        color: '#a0aec0', fontSize: 18, lineHeight: 1, userSelect: 'none',
    }, children: "\u2715" }));
const overlayStyle = {
    position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)',
    display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000,
};
const cardStyle = {
    position: 'relative', background: '#fff', borderRadius: 14,
    padding: '28px 28px 24px', width: 340,
    boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
    maxHeight: '90vh', overflowY: 'auto',
};
const labelStyle = {
    display: 'block', fontSize: 13, fontWeight: 600, color: '#4a5568', marginBottom: 6,
};
const errorStyle = { color: '#e53e3e', fontSize: 12, marginTop: 4 };
const locale = {
    ru: {
        leaveRequest: 'Оставить заявку',
        contactSoon: 'Мы свяжемся с вами в ближайшее время',
        enterNameMin2: 'Введите имя (минимум 2 символа)',
        enterValidPhone: 'Введите корректный номер телефона',
        selectAtLeastOne: 'Выберите хотя бы один вариант',
        requiredField: 'Обязательное поле',
        requestSent: 'Заявка отправлена!',
        yourName: 'Ваше имя',
        name: 'Имя',
        phone: 'Телефон',
        selectPlaceholder: '— выберите —',
        sendError: 'Ошибка отправки. Попробуйте ещё раз позже.',
        sending: 'Отправка...',
        send: 'Отправить',
    },
    en: {
        leaveRequest: 'Submit a request',
        contactSoon: 'We’ll contact you shortly',
        enterNameMin2: 'Enter a name (at least 2 characters)',
        enterValidPhone: 'Enter a valid phone number',
        selectAtLeastOne: 'Select at least one option',
        requiredField: 'Required field',
        requestSent: 'Request sent!',
        yourName: 'Your name',
        name: 'Name',
        phone: 'Phone',
        selectPlaceholder: '— select —',
        sendError: 'Sending failed. Please try again later.',
        sending: 'Sending...',
        send: 'Send',
    },
    de: {
        leaveRequest: 'Anfrage senden',
        contactSoon: 'Wir melden uns in Kürze bei Ihnen',
        enterNameMin2: 'Geben Sie einen Namen ein (mindestens 2 Zeichen)',
        enterValidPhone: 'Geben Sie eine gültige Telefonnummer ein',
        selectAtLeastOne: 'Wählen Sie mindestens eine Option aus',
        requiredField: 'Pflichtfeld',
        requestSent: 'Anfrage gesendet!',
        yourName: 'Ihr Name',
        name: 'Name',
        phone: 'Telefon',
        selectPlaceholder: '— auswählen —',
        sendError: 'Fehler beim Senden. Bitte versuchen Sie es später erneut.',
        sending: 'Wird gesendet...',
        send: 'Senden',
    },
};
